import script from "./CreateAgentForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateAgentForm.vue?vue&type=script&setup=true&lang=js"

import "./CreateAgentForm.vue?vue&type=style&index=0&id=782faaba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-782faaba"]])

export default __exports__